<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.productRating')"
    resource="product_ratings"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ProductRatings extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'name_cont',
        label: this.$t('productRating.name'),
        renderCell: {
          component: 'input'
         }
      },
    ]
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
      },
      {
        prop: 'name',
        label: this.$t('productRating.name'),
      },
      {
        prop: 'created_at',
        label: this.$t('createdAt'),
        action: ['hide-in-table'],
        renderCell: 'time',
      },
      {
        prop: 'updated_at',
        label: this.$t('updatedAt'),
        action: ['hide-in-table'],
        renderCell: 'time',
      },
    ]

  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'name',
        label: this.$t('productRating.name'),
        renderCell: {
          required: true,
          component: 'input',
        },
      },
    ]
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'productRatings.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'product_ratings.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/product_ratings',
    name: 'product_ratings.index',
    component: ProductRatings,
    props: {
      type: 'index',
    }
  },
  {
    path: '/product_ratings/new',
    name: 'product_ratings.new',
    component: ProductRatings,
    props: {
      type: 'new',
    }
  },
  {
    path: '/product_ratings/:id',
    name: 'product_ratings.show',
    component: ProductRatings,
    props: {
      type: 'show',
    }
  },
  {
    path: '/product_ratings/:id/edit',
    name: 'product_ratings.edit',
    component: ProductRatings,
    props: {
      type: 'edit'
    }
  }
]
</script>
